import { getSiteInfo } from '../SiteConfigs.js';

function init_got_chosen_widget(){

    let SITE_INFO = getSiteInfo();

    if($('body').hasClass('polls') && $('.alpha .writeup').length) {
        return; // disabled on "writeup" pages
    }

    let $pos = $('body').attr('class');

    var data = {
        'ge_action' : 'Loaded',
        'ge_category' : 'Partner Widgets',
        'ge_label' : 'GotChosen : ' + $pos
    };

    //send_ga_event(data);

    if( !NO_IC ) {

        if($('body').hasClass('polls')){
            $('div.alpha').append('<div class="clear" style="margin-top:10px;"></div> <div class="ndn_article_body_title" style="display:none">Advertisement</div><div id="gotChosen"></div>');
        }else{
            $('#comments-container, #fb-comments-container').after('<div class="clear" style="margin-top:10px;"></div> <div class="ndn_article_body_title">Advertisement</div><div id="gotChosen"></div>');
        }
    }


    //Old Script
    // (function(e,t,n,r,i,s,o){e["GotChosenObject"]=i;e[i]=e[i]||function()
    // {(e[i].q=e[i].q||[]).push(arguments)},e[i].l=1*new
    // Date;s=t.createElement(n),o=t.getElementsByTagName(n)
    //     [0];s.async=1;s.src=r;o.parentNode.insertBefore(s,o)})
    // (window,document,"script","https://www.gotchosen.com/thirdparty/gc.js","gc");
    // gc("webcurtain", SITE_INFO['gotchosen_id'] , { widgets: { autoinstall: [ { type: 'carousel-multi', selector: '#gotChosen', insertion: 'into' } ] } });

    //New Script D.N - 5/1/2020
    (function(c,e,n,o,i,r,s,t,u,a,h,f,l,d,p){s="querySelector";a=new Date;d=0;
    c["GotChosenObject"]=o;c[o]=c[o]||function(){(c[o].q=c[o].q||[]).push(arguments);r=r||c[o].q.filter(function(t){return t[0]==="init"})[0][1];
    p=function(){try{try{h=[];c[o].q[0][2].widgets.autoinstall.forEach(function(t){h.push(t.selector)});
    h=h.join()}catch(t){h=".gcwp-carousel"}if(d<6e4&&!e[s]("#"+r)){if(e[s](h)){f=e.createElement(n);
        f.id=r;f.async=1;f.src=i+"/gcjs/"+r+"/gc.js?cb="+a.toJSON().slice(0,13);e.head.appendChild(f)}
        else{setTimeout(p,100)}d+=100}}catch(t){throw new Error(t)}};if(r){p()}}})(window,document,"script","gc","https://cdn.gotchosen.com"); 
        gc("init", SITE_INFO['gotchosen_id'], { widgets: { autoinstall: [{ selector: '#gotChosen' }] } });
}

export default init_got_chosen_widget;